export default "__VITE_ASSET__DAL$xyvp__"